import { showNotification } from '@/utils/notificationHelper';
import history from '@/utils/history';
import codeMessage from './codeMessage';

const errorHandler = (error) => {
  const { response } = error;

  if (response && response.status) {
    const message = response.data && response.data.message;

    const errorText = message || codeMessage[response.status];
    const { status } = response;

    showNotification.error({
      message: `Request error ${status}`,
      description: errorText,
    });

    if (response.data && response.data.jwtExpired) {
      history.push('/logout');
    }
    return response.data;
  } else {
    showNotification.error({
      message: 'No internet connection',
      description: 'Cannot connect to the server, Check your internet network',
    });

    return {
      success: false,
      result: null,
      message: 'Cannot connect to the server, Check your internet network',
    };
  }
};

export default errorHandler;
